module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael W. Austin, Marlena Graves\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Michael W. Austin")]), _vm._v(" is Foundation Professor of Philosophy at Eastern Kentucky University and Bonhoeffer Senior Fellow of the Miller Center for Interreligious Learning and Leadership of Hebrew College. He has published twelve books, most recently "), _c('I', [_vm._v("Humility: Rediscovering the Way of Love and Life in Christ")]), _vm._v(" and "), _c('I', [_vm._v("QAnon, Chaos, and the Cross: Christianity and Conspiracy Theories")]), _vm._v(".")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/RA1TO/tc-custom/9781467468596.jpg?1730406801631",
      "alt": "This image is the cover for the book American Christian Nationalism"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("American Christian Nationalism\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Michael W. Austin shows how nationalism is contrary to American values and Christian virtues—and offers us a better form of civic engagement.")]), _c('br'), _c('br'), _vm._v(" In this brief, thought-provoking book, Michael W. Austin turns his keen mind for ethics toward the crisis currently facing our democracy: the rise of American Christian nationalism. Austin first accessibly explains the meaning and history behind nationalism. He then systematically shows how the ideology contradicts American values like liberty, equality, and justice as well as Christian virtues like humility, faith, hope, and love. Ultimately, he argues that the Beloved Community, first developed by Martin Luther King Jr. and others, offers a better model for an authentically Christian and American community. Readers frustrated by partisan strife will find a faithful guide in Austin’s thoughtful volume.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing Co.\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0